/* eslint-disable no-undef */
import React, { Fragment, useState } from "react";
import { toast } from "react-toastify";
import { getDeliveryCharges } from "../../utils";

import axios from "axios";

import { PulseLoader } from "react-spinners";

import { useSelector } from "react-redux";

const CheckoutSection = ({ cartList, updateConfigs, token, configs, ...props }) => {
  const [placeOrderLoading, setPlaceOrderLoading] = useState(false);
  const totalPrices = useSelector((state) => state?.cartList?.totalPrice);

  const handleCreateOrder = async () => {
    setPlaceOrderLoading(true);
    await axios
      .post(
        "create-order",
        { paymentOption },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        if (res?.data) {
          if (paymentOption === "amazon") {
            const newTab = window.open("", "_blank");
            const htmlContent = res.data;
            if (newTab) {
              newTab.document.open();
              newTab.document.write(htmlContent);
              newTab.document.close();
            } else {
              alert("Popup blocked! Please allow popups for this site.");
            }
          } else if (paymentOption === "telr") {
            window.location.href = res.data.href;
          } else {
            window.location.href = res.data.href;
          }
        } else {
          toast.error(res?.data?.message);
        }
        setPlaceOrderLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something Went Wrong!");
        setPlaceOrderLoading(false);
      });
  };

  const currencySymbols = {
    EUR: "€",
    USD: "$",
    AED: "AED",
  };

  const currencyCode = localStorage.getItem("currency") || "AED";
  const currencyPrefix = currencySymbols[currencyCode] ? currencySymbols[currencyCode] + " " : "AED ";

  const [paymentOption, setPaymentOption] = useState("telr");

  const handlePaymentChange = (event) => {
    setPaymentOption(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (paymentOption === "") {
      alert("Please select a payment option!");
      return;
    }
  };

  const itemCount = cartList?.reduce((acc, it) => acc + (it.qty || 1), 0) || 0;
  const deliveryCharges = getDeliveryCharges();

  return (
    <Fragment>
      <section className="gpck-section">
        <div className="gpck-bg-orb gpck-bg-orb-tl" />
        <div className="gpck-bg-orb gpck-bg-orb-br" />

        <div className="gpck-inner">
          <div className="gpck-head">
            <div className="gpck-eyebrow">
              <span className="gpck-eyebrow-dot" />
              SECURE CHECKOUT
            </div>
            <h1 className="gpck-title">
              Review &amp; <span className="gpck-title-accent">place your order</span>
            </h1>
            <p className="gpck-sub">
              {itemCount} {itemCount === 1 ? "item" : "items"} ready to deliver — encrypted payment, instant delivery.
            </p>
          </div>

          <div className="gpck-grid">
            {/* LEFT: ORDER SUMMARY */}
            <div className="gpck-col-left">
              <div className="gpck-card">
                <div className="gpck-card-head">
                  <h2>Your Order</h2>
                  <span className="gpck-pill">{itemCount} {itemCount === 1 ? "item" : "items"}</span>
                </div>

                <div className="gpck-items">
                  {cartList?.map((item) => (
                    <div className="gpck-item" key={item.id}>
                      <div className="gpck-item-thumb">
                        <img src={item?.proimg?.[0]?.src} alt={item?.title} />
                      </div>
                      <div className="gpck-item-meta">
                        <h4>{item.title}</h4>
                        <span className="gpck-item-qty">
                          {currencyPrefix}{item.price} <span className="gpck-x">×</span> {item.qty}
                        </span>
                      </div>
                      <div className="gpck-item-price">
                        {currencyPrefix}{(item.qty * item.price).toFixed(2)}
                      </div>
                    </div>
                  ))}

                  {(!cartList || cartList.length === 0) && (
                    <div className="gpck-empty">Your cart is empty.</div>
                  )}
                </div>

                <div className="gpck-rows">
                  <div className="gpck-row">
                    <span>Delivery Charge</span>
                    <span>{currencyPrefix}{deliveryCharges}</span>
                  </div>
                  <div className="gpck-row">
                    <span>Subtotal</span>
                    <span>{currencyPrefix}{totalPrices}</span>
                  </div>
                  <div className="gpck-row gpck-row-total">
                    <span>Total</span>
                    <span className="gpck-total-amt">{currencyPrefix}{totalPrices}</span>
                  </div>
                </div>
              </div>

              {/* SECURITY NOTICE */}
              <div className="gpck-notice">
                <div className="gpck-notice-icon">
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
                    <path d="M12 2L2 7v7c0 5.55 3.84 10.74 10 12 6.16-1.26 10-6.45 10-12V7z" />
                  </svg>
                </div>
                <div className="gpck-notice-body">
                  <h4>Security Notice</h4>
                  <p>All transactions are secured using industry-standard encryption and 3D authentication where applicable.</p>
                  <h4>Billing Accuracy</h4>
                  <p>Please ensure your billing details match your card records to avoid delays.</p>
                  <a
                    href="https://wa.me/971545740174?text=Hello%20GlobalGiftPass%20support%2C%20I%20need%20help%20with%20my%20order."
                    target="_blank"
                    rel="noreferrer"
                    className="gpck-wa-btn"
                  >
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                      <path d="M20.52 3.48A11.94 11.94 0 0012.06 0C5.5 0 .19 5.31.19 11.86c0 2.09.55 4.13 1.6 5.93L0 24l6.34-1.66a11.85 11.85 0 005.71 1.45h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.4-8.45zM12.06 21.7h-.01a9.85 9.85 0 01-5.02-1.37l-.36-.21-3.76.98 1-3.66-.23-.38a9.83 9.83 0 01-1.51-5.2c0-5.45 4.43-9.88 9.88-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 012.89 6.99c0 5.45-4.43 9.83-9.87 9.83z" />
                    </svg>
                    Chat on WhatsApp
                  </a>
                </div>
              </div>
            </div>

            {/* RIGHT: PAYMENT */}
            <div className="gpck-col-right">
              <div className="gpck-card gpck-pay-card">
                <div className="gpck-card-head">
                  <h2>Payment Method</h2>
                </div>

                <form onSubmit={handleSubmit} className="gpck-pay-form">
                  <label className={`gpck-pay-opt ${paymentOption === "telr" ? "is-active" : ""}`} htmlFor="telrOption">
                    <input
                      type="radio"
                      name="paymentOption"
                      id="telrOption"
                      value="telr"
                      checked={paymentOption === "telr"}
                      onChange={handlePaymentChange}
                    />
                    <span className="gpck-pay-radio" />
                    <div className="gpck-pay-meta">
                      <h4>Visa / Mastercard</h4>
                      <p>Secure card payment via Telr · 3D Secure</p>
                    </div>
                    <div className="gpck-pay-badges">
                      <span className="gpck-card-chip gpck-chip-visa">VISA</span>
                      <span className="gpck-card-chip gpck-chip-mc">MC</span>
                    </div>
                  </label>

                  {/* mada option commented out as requested
                  <label className={`gpck-pay-opt ${paymentOption === "amazon" ? "is-active" : ""}`} htmlFor="amazonOption">
                    <input
                      type="radio"
                      name="paymentOption"
                      id="amazonOption"
                      value="amazon"
                      checked={paymentOption === "amazon"}
                      onChange={handlePaymentChange}
                    />
                    <span className="gpck-pay-radio" />
                    <div className="gpck-pay-meta">
                      <h4>mada bank card</h4>
                      <p>Pay using your Saudi mada debit card</p>
                    </div>
                    <img className="gpck-mada-logo" src="/mada.png" alt="mada-logo" />
                  </label>
                  */}
                </form>

                <div className="gpck-trust-row">
                  <div className="gpck-trust-item">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z" />
                    </svg>
                    3D Secure
                  </div>
                  <div className="gpck-trust-item">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" fill="none" />
                    </svg>
                    Encrypted
                  </div>
                </div>

                <div className="gpck-summary-mini">
                  <div className="gpck-summary-row">
                    <span>Subtotal</span>
                    <span>{currencyPrefix}{totalPrices}</span>
                  </div>
                  <div className="gpck-summary-row">
                    <span>Delivery</span>
                    <span>{currencyPrefix}{deliveryCharges}</span>
                  </div>
                  <div className="gpck-summary-row gpck-summary-total">
                    <span>Total</span>
                    <span>{currencyPrefix}{totalPrices}</span>
                  </div>
                </div>

                <button
                  className="gpck-place-btn"
                  onClick={handleCreateOrder}
                  disabled={placeOrderLoading}
                  type="button"
                >
                  {placeOrderLoading ? (
                    <PulseLoader size={9} color={"#0b0b0c"} />
                  ) : (
                    <>
                      <span>Place Order Securely</span>
                      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </>
                  )}
                </button>

                <p className="gpck-policy">
                  Your personal data will be used to process your order, support your experience, and for other purposes described in our privacy policy.
                </p>
              </div>
            </div>
          </div>
        </div>

        <style>{`
          .gpck-section {
            position: relative;
            background: linear-gradient(180deg, #07060a 0%, #0b0b0c 100%);
            color: #e6e8ec;
            padding: 60px 22px 90px;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            overflow: hidden;
            min-height: 100vh;
          }
          .gpck-bg-orb {
            position: absolute;
            width: 420px;
            height: 420px;
            border-radius: 50%;
            filter: blur(130px);
            opacity: 0.45;
            pointer-events: none;
          }
          .gpck-bg-orb-tl { background: rgba(212,168,87,0.18); top: -160px; left: -120px; }
          .gpck-bg-orb-br { background: rgba(212,168,87,0.12); bottom: -180px; right: -120px; }

          .gpck-inner {
            position: relative;
            max-width: 1180px;
            margin: 0 auto;
            z-index: 1;
          }

          .gpck-head { text-align: center; margin-bottom: 38px; }
          .gpck-eyebrow {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 6px 14px;
            background: rgba(212,168,87,0.1);
            border: 1px solid rgba(212,168,87,0.3);
            color: #d4a857;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 2px;
            margin-bottom: 14px;
          }
          .gpck-eyebrow-dot {
            width: 6px; height: 6px; border-radius: 50%;
            background: #d4a857;
            box-shadow: 0 0 10px #d4a857;
            animation: gpck-pulse 1.6s ease-in-out infinite;
          }
          @keyframes gpck-pulse {
            0%,100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.55; transform: scale(0.85); }
          }
          .gpck-title {
            font-family: "Playfair Display", "Times New Roman", serif;
            font-size: 34px;
            font-weight: 700;
            color: #fff;
            margin: 0 0 10px;
            line-height: 1.2;
          }
          .gpck-title-accent {
            background: linear-gradient(135deg, #f1cf85, #b58a3f);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            font-style: italic;
            font-weight: 600;
          }
          .gpck-sub { font-size: 14px; color: #9aa0a8; max-width: 560px; margin: 0 auto; line-height: 1.6; }

          .gpck-grid {
            display: grid;
            grid-template-columns: 1fr 0.85fr;
            gap: 22px;
            align-items: flex-start;
          }

          .gpck-card {
            background: linear-gradient(180deg, #15110a 0%, #1a1208 100%);
            border: 1px solid rgba(212,168,87,0.22);
            border-radius: 18px;
            padding: 26px;
            box-shadow: 0 12px 30px rgba(0,0,0,0.35);
          }
          .gpck-card-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 18px;
            padding-bottom: 14px;
            border-bottom: 1px solid rgba(212,168,87,0.15);
          }
          .gpck-card-head h2 {
            font-family: "Playfair Display", "Times New Roman", serif;
            font-size: 22px;
            color: #fff;
            margin: 0;
            font-weight: 700;
          }
          .gpck-pill {
            padding: 5px 12px;
            background: rgba(212,168,87,0.12);
            border: 1px solid rgba(212,168,87,0.28);
            color: #d4a857;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 1px;
            text-transform: uppercase;
          }

          .gpck-items { display: flex; flex-direction: column; gap: 12px; margin-bottom: 18px; }
          .gpck-item {
            display: grid;
            grid-template-columns: 56px 1fr auto;
            gap: 14px;
            align-items: center;
            padding: 12px;
            background: rgba(255,255,255,0.02);
            border: 1px solid rgba(255,255,255,0.06);
            border-radius: 12px;
            transition: border-color .25s ease, background .25s ease;
          }
          .gpck-item:hover {
            border-color: rgba(212,168,87,0.3);
            background: rgba(212,168,87,0.04);
          }
          .gpck-item-thumb {
            width: 56px;
            height: 56px;
            border-radius: 10px;
            overflow: hidden;
            background: #0b0b0c;
            border: 1px solid rgba(212,168,87,0.2);
          }
          .gpck-item-thumb img { width: 100%; height: 100%; object-fit: cover; }
          .gpck-item-meta h4 {
            font-size: 14.5px;
            color: #fff;
            margin: 0 0 4px;
            font-weight: 600;
            line-height: 1.3;
          }
          .gpck-item-qty { font-size: 12.5px; color: #9aa0a8; }
          .gpck-x { color: #d4a857; font-weight: 700; margin: 0 4px; }
          .gpck-item-price {
            font-size: 15px;
            color: #d4a857;
            font-weight: 700;
            white-space: nowrap;
          }
          .gpck-empty {
            padding: 30px;
            text-align: center;
            color: #9aa0a8;
            font-size: 14px;
          }

          .gpck-rows {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding-top: 16px;
            border-top: 1px dashed rgba(212,168,87,0.18);
          }
          .gpck-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            color: #c5c8cf;
          }
          .gpck-row span:last-child { color: #fff; font-weight: 600; }
          .gpck-row-total {
            margin-top: 10px;
            padding-top: 14px;
            border-top: 1px solid rgba(212,168,87,0.22);
            font-size: 16px;
          }
          .gpck-row-total span:first-child {
            font-family: "Playfair Display", "Times New Roman", serif;
            color: #fff;
            font-weight: 700;
            font-size: 18px;
          }
          .gpck-total-amt {
            font-size: 22px !important;
            background: linear-gradient(135deg, #f1cf85, #b58a3f);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent !important;
            font-weight: 700 !important;
          }

          /* NOTICE */
          .gpck-notice {
            margin-top: 18px;
            display: grid;
            grid-template-columns: 44px 1fr;
            gap: 14px;
            padding: 22px;
            background: linear-gradient(180deg, rgba(21,17,10,0.85) 0%, rgba(26,18,8,0.85) 100%);
            border: 1px solid rgba(212,168,87,0.18);
            border-radius: 18px;
          }
          .gpck-notice-icon {
            width: 44px; height: 44px;
            background: rgba(212,168,87,0.12);
            border: 1px solid rgba(212,168,87,0.28);
            color: #d4a857;
            border-radius: 12px;
            display: flex; align-items: center; justify-content: center;
          }
          .gpck-notice-body h4 {
            font-size: 13px;
            color: #d4a857;
            margin: 0 0 4px;
            font-weight: 700;
            letter-spacing: 0.4px;
            text-transform: uppercase;
          }
          .gpck-notice-body h4:not(:first-child) { margin-top: 14px; }
          .gpck-notice-body p { font-size: 13px; color: #9aa0a8; line-height: 1.55; margin: 0; }
          .gpck-notice-support {
            margin-top: 14px;
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px 12px;
            background: rgba(255,255,255,0.03);
            border: 1px solid rgba(212,168,87,0.18);
            border-radius: 10px;
          }
          .gpck-notice-support-label {
            font-size: 11px;
            color: #9aa0a8;
            text-transform: uppercase;
            letter-spacing: 1px;
            font-weight: 700;
          }
          .gpck-notice-support-num {
            font-size: 14px;
            color: #fff;
            font-weight: 700;
            margin-left: auto;
          }
          .gpck-wa-btn {
            margin-top: 12px;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 10px 18px;
            background: linear-gradient(135deg, #25d366, #128c7e);
            color: #fff;
            font-size: 13px;
            font-weight: 700;
            border-radius: 10px;
            text-decoration: none;
            transition: transform .2s ease, box-shadow .25s ease;
          }
          .gpck-wa-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 22px rgba(37,211,102,0.3);
            color: #fff;
            text-decoration: none;
          }

          /* PAYMENT */
          .gpck-pay-card { position: sticky; top: 110px; }
          .gpck-pay-form { display: flex; flex-direction: column; gap: 12px; margin-bottom: 16px; }
          .gpck-pay-opt {
            position: relative;
            display: grid;
            grid-template-columns: 22px 1fr auto;
            gap: 14px;
            align-items: center;
            padding: 16px 18px;
            background: rgba(255,255,255,0.02);
            border: 1px solid rgba(255,255,255,0.08);
            border-radius: 14px;
            cursor: pointer;
            transition: border-color .25s ease, background .25s ease, transform .2s ease;
            margin: 0;
          }
          .gpck-pay-opt:hover {
            border-color: rgba(212,168,87,0.35);
            background: rgba(212,168,87,0.04);
          }
          .gpck-pay-opt.is-active {
            border-color: rgba(212,168,87,0.6);
            background: rgba(212,168,87,0.08);
            box-shadow: 0 8px 22px rgba(212,168,87,0.12);
          }
          .gpck-pay-opt input { position: absolute; opacity: 0; pointer-events: none; }
          .gpck-pay-radio {
            width: 20px; height: 20px;
            border-radius: 50%;
            border: 2px solid rgba(212,168,87,0.4);
            background: transparent;
            display: inline-block;
            position: relative;
            transition: border-color .2s ease;
          }
          .gpck-pay-opt.is-active .gpck-pay-radio { border-color: #d4a857; }
          .gpck-pay-opt.is-active .gpck-pay-radio::after {
            content: "";
            position: absolute;
            inset: 3px;
            background: linear-gradient(135deg, #f1cf85, #b58a3f);
            border-radius: 50%;
          }
          .gpck-pay-meta h4 {
            font-size: 15px;
            color: #fff;
            margin: 0 0 3px;
            font-weight: 700;
          }
          .gpck-pay-meta p { font-size: 12.5px; color: #9aa0a8; margin: 0; }
          .gpck-pay-badges { display: inline-flex; gap: 6px; }
          .gpck-card-chip {
            padding: 4px 9px;
            font-size: 10px;
            font-weight: 800;
            border-radius: 6px;
            letter-spacing: 0.5px;
          }
          .gpck-chip-visa { background: #1a1f71; color: #fff; }
          .gpck-chip-mc { background: linear-gradient(135deg, #eb001b, #f79e1b); color: #fff; }
          .gpck-mada-logo {
            width: 64px;
            background: #fff;
            padding: 4px 6px;
            border-radius: 6px;
          }

          .gpck-trust-row {
            display: flex;
            gap: 8px;
            justify-content: center;
            padding: 12px;
            background: rgba(255,255,255,0.02);
            border: 1px dashed rgba(212,168,87,0.18);
            border-radius: 12px;
            margin-bottom: 16px;
          }
          .gpck-trust-item {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 11.5px;
            color: #d4a857;
            font-weight: 700;
            letter-spacing: 0.4px;
            text-transform: uppercase;
          }

          .gpck-summary-mini {
            padding: 14px 16px;
            background: rgba(255,255,255,0.03);
            border: 1px solid rgba(212,168,87,0.18);
            border-radius: 12px;
            margin-bottom: 14px;
          }
          .gpck-summary-row {
            display: flex;
            justify-content: space-between;
            font-size: 13px;
            color: #9aa0a8;
            margin-bottom: 6px;
          }
          .gpck-summary-row span:last-child { color: #fff; font-weight: 600; }
          .gpck-summary-row.gpck-summary-total {
            margin-top: 10px;
            padding-top: 10px;
            border-top: 1px solid rgba(212,168,87,0.2);
            font-size: 15px;
          }
          .gpck-summary-total span:first-child {
            font-family: "Playfair Display", "Times New Roman", serif;
            color: #fff;
            font-weight: 700;
            font-size: 16px;
          }
          .gpck-summary-total span:last-child {
            font-size: 18px !important;
            background: linear-gradient(135deg, #f1cf85, #b58a3f);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent !important;
            font-weight: 700;
          }

          .gpck-place-btn {
            width: 100%;
            padding: 16px;
            background: linear-gradient(135deg, #f1cf85, #d4a857 50%, #b58a3f);
            color: #0b0b0c;
            border: none;
            border-radius: 12px;
            font-size: 15px;
            font-weight: 800;
            letter-spacing: 0.4px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            transition: transform .2s ease, box-shadow .25s ease, opacity .2s ease;
            text-transform: uppercase;
            min-height: 54px;
          }
          .gpck-place-btn:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 14px 30px rgba(212,168,87,0.35);
          }
          .gpck-place-btn:disabled { opacity: 0.7; cursor: not-allowed; }

          .gpck-policy {
            margin-top: 14px;
            font-size: 11.5px;
            color: #6e7480;
            line-height: 1.55;
            text-align: center;
          }

          @media (max-width: 991px) {
            .gpck-grid { grid-template-columns: 1fr; }
            .gpck-pay-card { position: static; }
            .gpck-title { font-size: 26px; }
          }
          @media (max-width: 575px) {
            .gpck-section { padding: 40px 14px 70px; }
            .gpck-card { padding: 20px; }
            .gpck-title { font-size: 22px; }
            .gpck-item { grid-template-columns: 48px 1fr auto; padding: 10px; }
            .gpck-item-thumb { width: 48px; height: 48px; }
            .gpck-pay-opt { padding: 14px; }
            .gpck-pay-badges { display: none; }
          }
        `}</style>
      </section>
    </Fragment>
  );
};

export default CheckoutSection;
